import {ThunkDispatch} from 'redux-thunk';
import {AnyAction} from 'redux';
import types from './types';
import api from '../../api';
import {DialogCallbacks} from '../../types/common';
import {dispatchAsync} from '../common';
import {IArchiveSettings} from '../../types/ArchiveSettings';
import {IJobSettings} from '../../types/JobSettings';
import ApiService from '../../api/ApiService';
import {action} from '../helpers';
import {IITSupportEmailSettings} from '../../types/ITSupportEmailSettings';
import {ILogFileSettings} from '../../types/LogFileSettings';
import {ISessionData} from '../../types/SessionData';
import {FormOnSubmitHelpers} from 'components/hook-form/Formik';

export default {
   saveAuditTrailSettings: (payload: any, callbacks: FormOnSubmitHelpers<any>) => (
      dispatch: ThunkDispatch<{}, {}, AnyAction>
   ) => dispatch(action(types.SAVE_AUDIT_TRAIL_SETTINGS.SAGA, payload, callbacks)),
   getJobSettings: dispatchAsync(api.jobSettings, types.GET_JOB_SETTINGS),
   postJobSettings: (data: IJobSettings, cbs?: DialogCallbacks) =>
      dispatchAsync(api.jobSettings, types.POST_JOB_SETTINGS, {
         ...cbs,
         getMethod: ApiService.postSecureJson,
         data,
      }),

   getArchiveSettings: dispatchAsync(api.archiveSettings, types.GET_ARCHIVE_SETTINGS),
   postArchiveSettings: (data: IArchiveSettings, cbs?: DialogCallbacks) =>
      dispatchAsync(api.archiveSettings, types.POST_ARCHIVE_SETTINGS, {
         ...cbs,
         getMethod: ApiService.postSecureJson,
         data,
      }),

   getSupportEmailSettings: dispatchAsync(
      api.supportEmailSettings,
      types.GET_SUPPORT_EMAIL_SETTINGS
   ),
   postSupportEmailSettings: (data: IITSupportEmailSettings, cbs?: DialogCallbacks) =>
      dispatchAsync(api.supportEmailSettings, types.POST_SUPPORT_EMAIL_SETTINGS, {
         ...cbs,
         getMethod: ApiService.postSecureJson,
         data,
      }),

   getLogginSettings: dispatchAsync(api.logFileSettings, types.GET_LOGGING_SETTINGS),
   postLogginSettings: (data: ILogFileSettings, cbs?: DialogCallbacks) =>
      dispatchAsync(api.logFileSettings, types.POST_LOGGING_SETTINGS, {
         ...cbs,
         getMethod: ApiService.postSecureJson,
         data,
      }),

   getSessionSettings: dispatchAsync(api.sessionData, types.GET_SESSION_SETTINGS),
   postSessionSettings: (data: ISessionData, cbs?: DialogCallbacks) =>
      dispatchAsync(api.sessionData, types.POST_SESSION_SETTINGS, {
         ...cbs,
         getMethod: ApiService.postSecureJson,
         data,
      }),

   getBackupSettings: () => dispatchAsync(api.backupSettings, types.GET_BACKUP_SETTINGS),
   getJobHistorySettings: () =>
      dispatchAsync(api.jobHistorySettings, types.GET_JOB_HISTORY_SETTINGS),
   getFTPSettings: () => dispatchAsync(api.settingsFTP, types.GET_FTP_SETTINGS),
   getKeySettings: () => dispatchAsync(api.keysSettings, types.GET_KEY_SETTINGS),
   getAuditTrailSettings: () =>
      dispatchAsync(api.auditTrailSettings, types.GET_AUDIT_TRAIL_SETTINGS),
   getEmailSettings: () => dispatchAsync(api.emailSettings, types.GET_EMAIL_SETTINGS),
   getPagingSettings: () => dispatchAsync(api.pagingSettings, types.GET_PAGING_SETTINGS),
   fetchAdminRoles: dispatchAsync(api.adminroles, types.FETCH_ADMIN_ROLES),
   //@not used
   fetchAdminRoleById: (id: string) =>
      dispatchAsync(`${api.rolesForUser}/${id}`, types.FETCH_ADMIN_ROLE_BY_ID),
};
